import articleStyles from '../../../styles/Article.module.css'
import Meta from '../../../components/Meta'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import ArticlePost from '../../../components/Article/ArticlePost'
import { supabase } from "../../../utils/supabaseClient"
import { useAuth } from '../../../contexts/Auth'
import { useState, useEffect } from "react";
import dynamic from 'next/dynamic'
import { cloudfront } from '../../../config'

export async function getStaticPaths() {
  const {data: articles, error} = await supabase
    .from('main_article')
    .select('id, article_status, article_slug, main_tag(id, tag_name)')
    .filter('article_status', 'eq', 'published')
    .order('article_published', { ascending: false })
  
  error && console.log(error)
    
  const paths = articles.map((article) => ({ params: { slug: article.article_slug }}))
  return {
    paths,
    fallback: 'blocking'
  }
}

export async function getStaticProps(context) {
    //the article
   let { data: article, error } = await supabase
    .from('main_article')
    .select(`
    id, article_status, article_title, article_published, article_content,
    article_image, article_slug, reading_time, like_total, test_content,
    main_tag (
      id, tag_name
    ),
    main_profile!main_article_profile_fkey (
       user_image, twitter_handle, bio, gthr_link, username
    )
    `)
    .filter('article_slug', 'eq', context.params.slug)
    .single()
    
    if (article.article_content.substring(0,150).includes("strong")) {
      article["meta_description"] = article.article_content.substring(article.article_content.indexOf("</strong>")+9).replace( /(<([^>]+)>)/ig, '').substring(0,160)
    } else {
      article["meta_description"] = article.article_content.replace( /(<([^>]+)>)/ig, '').substring(0,150)
    }

  error && console.log(error)

  if (!article) {
    return {
      notFound: true,
    }
  }

  const tags = article.main_tag.map((tag) => tag.tag_name)
  // console.log("tags:" + tags)

  //related articles
 const articles = await supabase
  .from("main_article")
  .select(`
    id, article_status, article_title, article_published, article_image, article_slug, reading_time,
    main_profile!main_article_profile_fkey (
      username,
      user_image
    ),
    main_tag (
      id, 
      tag_name
  )`
  ).filter('article_slug', 'neq', context.params.slug)
  .filter('article_status', 'eq', 'published')
  .order('article_published', { ascending: false })

  
  articles.error && console.log(articles.error)
  //filter by the article's tags
  let relArticles = articles.data.filter(obj => {
    let tagBool = false;
    const relTagList = obj.main_tag.map((tag) => tag.tag_name)
    
    if (relTagList.length > 0) {
      tags.some(tag_name => {
        tagBool = relTagList.includes(tag_name)
        return tagBool && tagBool;
      })} 
    return tagBool
  })

  relArticles = relArticles.slice(0,6)

  if (!articles) {
    return 
  }


  return {
    props: {
      article,
      relArticles
    },
    revalidate: 120
  }


}

const RegisterModal = dynamic(() => import("../../../components/User/RegisterModal"))
const ArticleButtonsProfile = dynamic(() => import('../../../components/Article/ArticleButtonsProfile'))
const BlogList = dynamic(() => import('../../../components/Blog/BlogList'))

export default function Article(props) {
  const [showRegisterModal, setRegisterModal] = useState(false);
  const { user, signInGoogle, signOut, signIn } = useAuth()
  const handleRegisterModal = () => { setRegisterModal(true) }

  useEffect(() => {
    window.ezstandalone = window.ezstandalone || {};
    ezstandalone.cmd = ezstandalone.cmd || [];
    ezstandalone.cmd.push(function() {
        ezstandalone.define(102,103,104, 106);
        if (!ezstandalone.enabled) {
          ezstandalone.enable();
          ezstandalone.display();
        } else {
          ezstandalone.refresh();
        }
    });
  },[])

  return (
    <>
      <Meta 
        title={props.article.article_title} 
        description={props.article.meta_description}
        image={`${cloudfront}/media/${props.article.article_image}`} 
        url={`https://ordinarycoders.com/blog/article/${props.article.article_slug}`} 
      />
      <RegisterModal 
                    show={showRegisterModal} 
                    signInGoogle={signInGoogle} 
                    signIn={signIn}
                    setShow={setRegisterModal}
                    
                />
      <Container className="py-5 px-15">
         <Row>
           <Col xl={9} lg={12}>
            <ArticlePost article={props.article} handleRegisterModal={handleRegisterModal} user={user}/>
           </Col>
           <Col xl={3} lg={12}>
            <div className={`ps-md-3 ${articleStyles.about_col}`}>
               <ArticleButtonsProfile article={props.article} handleRegisterModal={handleRegisterModal}  user={user}/>
             </div>
           </Col>
         </Row>
       </Container>
        <Container className="py-5 px-15">
          <BlogList articles={props.relArticles} />
          <div id="ezoic-pub-ad-placeholder-106"> </div>
        </Container>
    </> 
  )
}